import {
  Component, Input, Output, OnInit, EventEmitter, Pipe,
  PipeTransform, ChangeDetectionStrategy, ChangeDetectorRef, Renderer2, ElementRef,
  ViewChild, ViewContainerRef, ViewEncapsulation, QueryList, ViewChildren, Query
} from '@angular/core';
import { FormsModule, FormGroup, FormControl, Validators, NgForm } from '@angular/forms';
import { Session_PreQuestionNumberModel } from '../Models/Model/Session_PreQuestionNumberModel';
import { aspNetControl } from '../Enum/ASPNetControl';
import { typeInfo } from '../Enum/TypeInfo';
import { ControlsComponent } from '../Controls/controls.component';
import { formService } from '../Service/formService';

@Component({
  selector: 'prequestionaire',
  templateUrl: 'preQuestionaire.component.html',
  styleUrls: ['preQuestionaire.component.css', '../../styles.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [ControlsComponent, FormsModule]
})
export class PreQuestionaireComponent {
  @ViewChildren(ControlsComponent) ControlsComponents: QueryList<ControlsComponent> | null | undefined = undefined;
  @ViewChildren(PreQuestionaireComponent) PreQuestionaireComponents: QueryList<PreQuestionaireComponent> | null | undefined = undefined;

  public ASPNetControl = aspNetControl;
  private TypeInfo = typeInfo;

  @Input() preQuestionItems: Array<Session_PreQuestionNumberModel> | null | undefined = undefined;

  constructor(private cdRef: ChangeDetectorRef,
    private FormService: formService) {
  }

  //Is the questionaire valid
  get valid() {
    let formvalid: boolean = true;

    if (this.ControlsComponents) {
      this.ControlsComponents.forEach(
        (item) => {
          if (!item.isValid()) {
            formvalid = false;
          }
        });
    }
    if (this.PreQuestionaireComponents) {
      this.PreQuestionaireComponents.forEach(
        (item) => {
          if (!item.valid) {
            formvalid = false;
          }
        });
    }
    return formvalid;
  }

  //Add a default group
  adddefaultgroup = (item: Session_PreQuestionNumberModel) => {
    if (item.preQuestionNumber.length == 0) {
      this.FormService.addgroup(item);
    }
    return false;
  }

  //Add a group
  addgroup = (item: Session_PreQuestionNumberModel) => {
    this.FormService.addgroup(item);
  }

  //Remove a group
  removegroup = (item: Session_PreQuestionNumberModel, preQuestionItems: Array<Session_PreQuestionNumberModel> | null | undefined) => {
    if (preQuestionItems) {
      this.FormService.removegroup(item, preQuestionItems);
    }
  }

  //Is this the last item of the group
  isLastItemOfGroup = (item: Session_PreQuestionNumberModel, preQuestionItems: Array<Session_PreQuestionNumberModel>): boolean => {
    return this.FormService.isLastItemInGroup(item, preQuestionItems);
  }

  //Is this first item of a group
  isFirstItemOfGroup = (item: Session_PreQuestionNumberModel, preQuestionItems: Array<Session_PreQuestionNumberModel> | null | undefined): boolean => {
    if (preQuestionItems) {
      return this.FormService.isFirstItemInGroup(item, preQuestionItems);
    }
    else {
      return false;
    }
  }

  ngAfterViewChecked() {
    this.FormService.Calculation();
  }

  index = (index: any, item: Session_PreQuestionNumberModel) => {
    return item.index;
  }
}
